import React, { useRef, useState } from 'react';
import clsx from 'clsx';

import { BaseComponentProps } from '@utils/types/baseComponents';
import { MinMaxType } from '@utils/types/searchListingsContext';
import { useClickOutside } from '@utils/hooks/useClickOutside';
import { MinMaxSelectors } from '@components/search/minMaxSelectors';
import { bedroomsOptions, renderBedroomsValue } from '@components/search/utils';

import styles from './styles.module.scss';

type Props = {
  value: MinMaxType;
  onChange: (value: MinMaxType) => void;
} & BaseComponentProps;

BedroomSelectors.defaultProps = {
  value: { min: '', max: '' },
};

export function BedroomSelectors(props: Props) {
  const { containerStyle, value, onChange } = props;
  const [showContainer, setShowContainer] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const toggleContainer = () => setShowContainer((value) => !value);

  const closeContainer = () => setShowContainer(false);

  useClickOutside(containerRef, closeContainer);

  return (
    <div
      ref={containerRef}
      className={clsx([styles.bedroomSelectors, containerStyle])}
    >
      <div
        className={styles.bedroomSelectors__toggle}
        onClick={toggleContainer}
      >
        {renderBedroomsValue(value)}
      </div>

      {showContainer && (
        <div
          className={styles.bedroomSelectors__popup}
          onClick={(e) => e.stopPropagation()}
        >
          <MinMaxSelectors
            value={value}
            onChange={onChange}
            options={bedroomsOptions}
            selectorStyle={styles.bedroomSelectors__selector}
            emptyValue={'Any'}
          />
        </div>
      )}
    </div>
  );
}
